<template>
  <span v-if="isDeleted" class="text-sm truncate secondary_color">
    {{ cleanName }}
    <span> (Removed user) </span>
  </span>
  <span v-else class="truncate text_color text-sm">
    {{ name }}
  </span>
</template>

<script setup>
import { computed } from "vue";
import { getCleanUserName } from "@/src/utils/utils.js";

const props = defineProps({
  name: { type: String, default: "" },
  isDeleted: { type: Boolean, default: false },
});

const cleanName = computed(() => getCleanUserName(props.name));
</script>
